export const getQueryParam = (queryParam: string) => {
  const params = new URLSearchParams(location.search);
  return params.get(queryParam);
};
